import { Component, Input } from '@angular/core';
import { BuyersService } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Order, OrdersService } from 'src/app/core/orders.service';
import { ERROR_ORDER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-buyer-details-order-data',
  templateUrl: './buyer-details-order-data.component.html',
  styleUrls: ['./buyer-details-order-data.component.scss'],
})
export class BuyerDetailsOrderDataComponent {
  @Input() buyer_id?: string | null;
  orders?: Order[];
  is_read_running = true;

  constructor(private buyers_service: BuyersService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.orders = [];
    if (this.buyer_id) this.listOrders(this.buyer_id);
  }

  onRefresh(): void {
    this.orders = [];
    if (this.buyer_id) this.listOrders(this.buyer_id);
  }

  listOrders(buyer_id?: string): void {
    this.is_read_running = true;

    if (buyer_id) {
      this.buyers_service.listOrders(buyer_id).subscribe({
        next: response => {
          this.orders = response.data;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_ORDER_NOT_FOUND) {
            this.orders = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
